import { sortBy } from 'lodash-es';

export const layers = sortBy(
  [
    {
      id: 'n-protectant-centuro-spring',
      featureId: 'n-protectant-centuro',
      name: 'Centuro - Spring',
      filters: { productTiming: 'spring' },
    },
    {
      id: 'n-protectant-centuro-fall-early-spring',
      featureId: 'n-protectant-centuro',
      name: 'Centuro - Fall/Early Spring',
      filters: { productTiming: 'fall/early spring' },
    },
    {
      id: 'n-protectant-centuro-early-sidedress',
      featureId: 'n-protectant-centuro',
      name: 'Centuro - Early Sidedress',
      filters: { productTiming: 'early_sidedress' },
    },
    {
      id: 'n-protectant-centuro-late-sidedress',
      featureId: 'n-protectant-centuro',
      name: 'Centuro - Late Sidedress',
      filters: { productTiming: 'late_sidedress' },
    },
    {
      id: 'n-protectant-function-spring',
      featureId: 'n-protectant-function',
      name: 'Function - Spring',
      filters: { productTiming: 'spring' },
    },
    {
      id: 'n-protectant-function-fall-early-spring',
      featureId: 'n-protectant-function',
      name: 'Function - Fall/Early Spring',
      filters: { productTiming: 'fall/early spring' },
    },
    {
      id: 'n-protectant-function-early-sidedress',
      featureId: 'n-protectant-function',
      name: 'Function - Early Sidedress',
      filters: { productTiming: 'early_sidedress' },
    },
    {
      id: 'n-protectant-function-late-sidedress',
      featureId: 'n-protectant-function',
      name: 'Function - Late Sidedress',
      filters: { productTiming: 'late_sidedress' },
    },
    {
      id: 'n-protectant-guardian-l-spring',
      featureId: 'n-protectant-guardian-l',
      name: 'Guardian-L - Spring',
      filters: { productTiming: 'spring' },
    },
    {
      id: 'n-protectant-guardian-l-fall-early-spring',
      featureId: 'n-protectant-guardian-l',
      name: 'Guardian-L - Fall/Early Spring',
      filters: { productTiming: 'fall/early spring' },
    },
    {
      id: 'n-protectant-guardian-l-early-sidedress',
      featureId: 'n-protectant-guardian-l',
      name: 'Guardian-L - Early Sidedress',
      filters: { productTiming: 'early_sidedress' },
    },
    {
      id: 'n-protectant-guardian-l-late-sidedress',
      featureId: 'n-protectant-guardian-l',
      name: 'Guardian-L - Late Sidedress',
      filters: { productTiming: 'late_sidedress' },
    },
    {
      id: 'n-protectant-instinct-spring',
      featureId: 'n-protectant-instinct',
      name: 'Instinct - Spring',
      filters: { productTiming: 'spring' },
    },
    {
      id: 'n-protectant-instinct-fall-early-spring',
      featureId: 'n-protectant-instinct',
      name: 'Instinct - Fall/Early Spring',
      filters: { productTiming: 'fall/early spring' },
    },
    {
      id: 'n-protectant-instinct-early-sidedress',
      featureId: 'n-protectant-instinct',
      name: 'Instinct - Early Sidedress',
      filters: { productTiming: 'early_sidedress' },
    },
    {
      id: 'n-protectant-instinct-late-sidedress',
      featureId: 'n-protectant-instinct',
      name: 'Instinct - Late Sidedress',
      filters: { productTiming: 'late_sidedress' },
    },
    {
      id: 'n-protectant-instinct-nxtgen-spring',
      featureId: 'n-protectant-instinct-nxtgen',
      name: 'Instinct NXTGEN - Spring',
      filters: { productTiming: 'spring' },
    },
    {
      id: 'n-protectant-instinct-nxtgen-fall-early-spring',
      featureId: 'n-protectant-instinct-nxtgen',
      name: 'Instinct NXTGEN - Fall/Early Spring',
      filters: { productTiming: 'fall/early spring' },
    },
    {
      id: 'n-protectant-instinct-nxtgen-early-sidedress',
      featureId: 'n-protectant-instinct-nxtgen',
      name: 'Instinct NXTGEN - Early Sidedress',
      filters: { productTiming: 'early_sidedress' },
    },
    {
      id: 'n-protectant-instinct-nxtgen-late-sidedress',
      featureId: 'n-protectant-instinct-nxtgen',
      name: 'Instinct NXTGEN - Late Sidedress',
      filters: { productTiming: 'late_sidedress' },
    },
    {
      id: 'n-protectant-n-serve-spring',
      featureId: 'n-protectant-n-serve',
      name: 'NServe - Spring',
      filters: { productTiming: 'spring' },
    },
    {
      id: 'n-protectant-n-serve-fall-early-spring',
      featureId: 'n-protectant-n-serve',
      name: 'NServe - Fall/Early Spring',
      filters: { productTiming: 'fall/early spring' },
    },
    {
      id: 'n-protectant-n-serve-early-sidedress',
      featureId: 'n-protectant-n-serve',
      name: 'NServe - Early Sidedress',
      filters: { productTiming: 'early_sidedress' },
    },
    {
      id: 'n-protectant-n-serve-late-sidedress',
      featureId: 'n-protectant-n-serve',
      name: 'NServe - Late Sidedress',
      filters: { productTiming: 'late_sidedress' },
    },
    {
      id: 'n-protectant-trident-spring',
      featureId: 'n-protectant-trident',
      name: 'Trident - Spring',
      filters: { productTiming: 'spring' },
    },
    {
      id: 'n-protectant-trident-fall-early-spring',
      featureId: 'n-protectant-trident',
      name: 'Trident - Fall/Early Spring',
      filters: { productTiming: 'fall/early spring' },
    },
    {
      id: 'n-protectant-trident-early-sidedress',
      featureId: 'n-protectant-trident',
      name: 'Trident - Early Sidedress',
      filters: { productTiming: 'early_sidedress' },
    },
    {
      id: 'n-protectant-trident-late-sidedress',
      featureId: 'n-protectant-trident',
      name: 'Trident - Late Sidedress',
      filters: { productTiming: 'late_sidedress' },
    },
  ],
  'id',
);
